"use strict";

const displayQuestions = ($container) => {
    let maxQuestionsToShow;
    let defaultMaxQuestionsToShow;

    try {
        defaultMaxQuestionsToShow = parseInt($(".js-default-max-show-quantity", $container).val(), 10);
        maxQuestionsToShow        = parseInt($container.data("faqs-to-show"), 10);
    } catch (e) {
        maxQuestionsToShow = defaultMaxQuestionsToShow;
    }

    const shouldDisplayAllQuestions = Boolean($container.data("show-all"));

    $(".js-faq-question", $container).each(function (index) {
        const $currentQuestion = $(this);

        if (index < maxQuestionsToShow || shouldDisplayAllQuestions) {
            $currentQuestion.removeAttr("hidden");
        } else {
            $currentQuestion.attr("hidden", "true");
        }
    });
};

const initFaqAccordionBehavior = ($container) => {
    //Hide the question that are not being shown at the start by limitation on the number of questions.
    displayQuestions($container);

    //On click on the Question Header, the class "collapsed" is toggled on the element
    $(".js-faq-question-header", $container).on("click", function () {
        const $questionHeader    = $(this);
        const $questionContent   = $questionHeader.siblings(".js-faq-question-content");
        const $questionContainer = $questionHeader.parents(".js-faq-question");

        $questionContainer.toggleClass("collapsed");

        $questionContent.css(
            "max-height",
            $questionContainer.hasClass("collapsed") ? `${$questionContent.prop("scrollHeight")}px` : 0
        );
    });

    $(".js-faq-show-more", $container).on("click", function () {
        const shouldDisplayAllQuestions = Boolean($container.data("show-all"));
        const $seeMoreButton            = $(this);

        if (shouldDisplayAllQuestions) {
            $seeMoreButton.text($seeMoreButton.data("see-more-text"));
        } else {
            $seeMoreButton.text($seeMoreButton.data("see-less-text"));
        }

        $container.data("show-all", !shouldDisplayAllQuestions);
        displayQuestions($container);
    });
};

const initializeFaqScripts = () => {
    const $container = $(".js-pd-faq");

    if ($container.length === 0) {
        return;
    }

    $container.each(function () {
        initFaqAccordionBehavior($(this));
    });
};

export default initializeFaqScripts;
